var $pageUp, 
	$pageDown;

function updateNav(active){
	if(active.is('header')){
		$pageUp.addClass('hidden')
	} else{
		$pageUp.removeClass('hidden')
	}
	if(active.is('.personal-section')){
		$pageDown.addClass('hidden')
	} else{
		$pageDown.removeClass('hidden')
	}
}

var isTurning = false;
function pageTurn(dir){
	isTurning = true;
	var active = $('.gbl.page-active');
	var offset = $(window).height();
	var target;
	if(!dir){
		target = active.next();
	} else{
		target = active.prev();
	}
	var offsetLanding = target.data('offset') - offset;
	if(target.is('header') || target.is('.personal-section') || $(window).width() < 1025){
		offset = 0;
		offsetLanding = 0;
	} 
	if($(window).width() < 1025){
		offset = 0.5 * $(window).height();
	} 
	// animScroll(target.offset().top - $('html,body').scrollTop());

	var dest = target.offset().top - $('html,body').scrollTop() + offset;
	var speed = 0.33 * Math.abs($(window).scrollTop() - dest);
	$('html, body').animate({
		scrollTop: dest + offsetLanding
	}, 1000, 'swing',function(){
		// clearTimeout(isTurning);
		// isTurning = setTimeout(function(){
		// 	$('html, body').animate({
		// 		scrollTop: dest + $(window).height()
		// 	}, 600, 'swing');
		// },1000)
		isTurning = false;
	});
}

$(function(){
	$pageUp = $('.nav.nav-up');
	$pageDown = $('.nav.nav-down');
	$pageUp.click(function(){
		if(!isTurning){
			pageTurn(-1);
		}
	});
	$pageDown.click(function(){
		if(!isTurning){
			pageTurn();
		}
	});
	$('#homeRoad').click(function(){
		isTurning = true;
		$('html, body').animate({
			scrollTop: 0
		}, 1000, 'swing',function(){
			isTurning = false;
		});
	})
});